import { Form, Mentions, Select } from 'antd'
import React, { useMemo } from 'react'
import { EnterOutlined } from "@ant-design/icons";

const modes = [
  {
    label: "List a partir da AI (Parametros)",
    value: "AI_OPTIONS"
  },
  {
    label: "List fixa",
    value: "OPTIONS"
  }
]

export default function SendList({ fieldName, parameters, form }) {
  const mode = Form.useWatch(['actions', fieldName, 'action', 'data', 'mode'], form)

  const available = useMemo(() => {
    const props = parameters?.properties
    if (!props) return []
    const arr = Array.isArray(props)
      ? props
      : Object.entries(props).map(([name, schema]) => ({ name, ...schema }))
    return arr.map(({ name }) => ({ label: name, value: name }))
  }, [parameters])

  const availableArrayString = useMemo(() => {
    const props = parameters?.properties
    if (!props) return []
    const arr = Array.isArray(props)
      ? props
      : Object.entries(props).map(([name, schema]) => ({ name, ...schema }))
    return arr
      .filter(({ type, items }) => type === 'array' && items?.type === 'string')
      .map(({ name }) => ({ label: name, value: name }))
  }, [parameters])

  return (
    <>
      <Form.Item
        label={'Titulo da lista de opções'}
        name={[fieldName, 'action', 'data', 'title']}
        rules={[
          {
            required: true,
            message: "O título é obrigatório"
          },
          {
            max: 60,
            message: 'Deve ter no máximo 60 caracteres'
          }
        ]}
      >
        <Mentions
          placeholder={'Use $ para selecionar um parametro'}
          options={available}
          prefix={'$'}
        />
      </Form.Item>
      <Form.Item
        label={'Corpo da mensagem'}
        name={[fieldName, 'action', 'data', 'body']}
        rules={[
          {
            required: true,
            message: "O corpo é obrigatório"
          },
          {
            max: 1024,
            message: 'Deve ter no máximo 1024 caracteres'
          }
        ]}
      >
        <Mentions
          placeholder={'Use $ para selecionar um parametro'}
          options={available}
          prefix={'$'}
        />
      </Form.Item>
      <Form.Item
        label={'Footer da mensagem'}
        name={[fieldName, 'action', 'data', 'footer']}
        rules={[
          {
            max: 60,
            message: 'Deve ter no máximo 60 caracteres'
          }
        ]}
      >
        <Mentions
          placeholder={'Use $ para selecionar um parametro'}
          options={available}
          prefix={'$'}
        />
      </Form.Item>
      <Form.Item
        label={'Mensagem no botão'}
        name={[fieldName, 'action', 'data', 'button']}
        rules={[
          {
            required: true,
            message: "O botão é obrigatório"
          },
          {
            max: 20,
            message: 'Deve ter no máximo 20 caracteres'
          }
        ]}
      >
        <Mentions
          placeholder={'Use $ para selecionar um parametro'}
          options={available}
          prefix={'$'}
        />
      </Form.Item>
      <Form.Item
        label={'Titulo da sessão'}
        name={[fieldName, 'action', 'data', 'sectionTitle']}
        rules={[
          {
            required: true,
            message: "O título da sessão é obrigatório"
          },
          {
            max: 24,
            message: 'Deve ter no máximo 24 caracteres'
          }
        ]}
      >
        <Mentions
          placeholder={'Use $ para selecionar um parametro'}
          options={available}
          prefix={'$'}
        />
      </Form.Item>
      <Form.Item name={[fieldName, 'action', 'data', 'mode']}
        initialValue={'BUTTONS'}
        label={'Modo dos botões'}>
        <Select options={modes} placement={"Selecione o modo de botões"} />
      </Form.Item>
      {mode === 'AI_BUTTONS' && <Form.Item
        label={'Botões gerados por AI'}
        name={[fieldName, 'action', 'data', 'aiButtons']}
        help={'Selecione um parametro do gatilho que seja uma lista de textos'}
      >
        <Select placeholder={'Selecione um parametro do gatilho'} options={availableArrayString} />
      </Form.Item>}
      {mode === 'OPTIONS' && <Form.Item
        label={'Botões fixos'}
        rules={[
          {
            required: true,
            message: "É obrigatório adicionar pelo menos uma opção.",
          },
          {
            validator: (_, value) => {
              if (value && value.some(v => v.length > 24)) {
                return Promise.reject(new Error('Cada opção deve ter no máximo 24 caracteres'));
              }
              return Promise.resolve();
            }
          }
        ]}
        validateTrigger={['onChange', 'onBlur']}
        name={[fieldName, 'action', 'data', 'options']}>
        <Select
          mode="tags"
          open={false}
          maxCount={10}
          suffixIcon={<EnterOutlined />}
          placeholder="Digite o conteúdo do botão e dê enter em seguida"
        />
      </Form.Item>}
      {mode === 'AI_OPTIONS' && <Form.Item
        label={'Botões gerados por AI'}
        name={[fieldName, 'action', 'data', 'aiOptions']}
        help={'Selecione um parametro do gatilho que seja uma lista de textos'}
      >
        <Select placeholder={'Selecione um parametro do gatilho'} options={availableArrayString} />
      </Form.Item>}
    </>
  )
}
